import React from "react";

function renderAlertIcon({ size }: { size: number }): React.JSX.Element {
  const viewBoxDimensions = size * 4;
  return (
    <svg
      height={size}
      viewBox={`0 0 ${viewBoxDimensions} ${viewBoxDimensions}`}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.7 41.6L48 11.2l-5-4.8-25.3 25.4L4.8 18.9 0 23.7l17.7 17.8z" />
    </svg>
  );
}

export function CopyToClipboardAlert({
  isVisible,
  message,
  dismiss,
}: {
  isVisible: boolean;
  message: string;
  dismiss: () => void;
}): React.ReactNode {
  const renderAlertDismissButton = ({ size }: { size: number }): React.JSX.Element => (
    <button className="button-unstyled alert-icon alert-dismiss" type="button" onClick={dismiss}>
      <svg
        height={size}
        viewBox={`0 0 ${size * 4} ${size * 4}`}
        width={size}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3.7 48L0 44.3 20.3 24 0 3.7 3.7 0 24 20.3 44.3 0 48 3.7 27.7 24 48 44.3 44.3 48 24 27.7 3.7 48z" />
      </svg>
    </button>
  );

  return (
    <div className="alert success copy-to-clipboard" data-alert-is-visible={isVisible}>
      <div className="icon">
        <span className="alert-icon">
          {renderAlertIcon({
            size: 12,
          })}
        </span>
      </div>
      <div className="message">{message}</div>
      <div className="action">
        {renderAlertDismissButton({
          size: 12,
        })}
      </div>
    </div>
  );
}

export default CopyToClipboardAlert;
